import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

import { PCStoreJsBridge } from '../../../nativeapi';
import styles from './Update.module.less';
import Toast from '../../../components/Toast/Toast';
import { logging } from '../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

let isQuickly;
export default memo(() => {
  const dispatch = useDispatch();
  const [isEnabled, setIsEnabled] = useState(true);
  const logInfoData = useSelector(selectLogInfo);
  const [isQuickly, setIsQuickly] = useState(false);

  const handleChoose = useCallback(() => {
    if (isQuickly) {
      Toast.error({
        content: '操作过于频繁，请稍后再试！',
      });
      return;
    }
    setIsQuickly(true);
    setTimeout(() => {
      setIsQuickly(false);
    }, 2000);
    PCStoreJsBridge.setAppStoreSwitch({
      type: 101,
      enable: !isEnabled,
      source: 1,
    }).then(res => {
      if (res.code !== 0 || !res.succ) {
        setIsEnabled(isEnabled);
        Toast.error({
          content: '设置失败！',
        });
      } else {
        setIsEnabled(!isEnabled);
        Toast.success({ content: '设置成功！', duration: 2 });
      }
    });
    PCStoreJsBridge.storeTrayCreate({
      type: !isEnabled ? 1 : 0,
    }).then(res => {});
    dispatch(
      logging({
        category: 'C',
        action: 'Tankuang_Enabled',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          enabled: isEnabled,
          type: 101,
        },
      }),
    );
  }, [isEnabled, isQuickly]);

  /**
   * type:  1 升级弹框   2 右键菜单开关   3 卸载残留弹窗开关   4 不常用软件弹窗开关
   * 5 未知文件  6 优质内容推送
   * 11 个性化推荐   12 优质内容推送      14 右键菜单
   * 101 托盘
   *
   * source 1：设置中心勾选框创建；2：关闭商店时创建；3：创建商店时创建
   */
  useEffect(() => {
    PCStoreJsBridge.getAppStoreSwitch({
      type: 101,
      source: 1,
    }).then(res => {
      if (res.succ) {
        setIsEnabled(!!res.enable);
      }
    });
  }, []);

  return (
    <div className={styles.s_update}>
      <div className="s_line">
        <div className="s_select_title">关闭商店:</div>
        <div className="s_content">
          <div className="checkbox checkbox_clear" onClick={handleChoose}>
            {isEnabled ? <div className="checked" /> : <div className="no_checked" />}
            <span>关闭商店时最小化到托盘</span>
          </div>
          <div className="desc desc_margin_top">快速直达商店功能。</div>
        </div>
      </div>
    </div>
  );
});
